import React, { Fragment, useState } from 'react';
import { CalendarDaysIcon, ClockIcon, StarIcon } from '@heroicons/react/20/solid'
import { Menu, RadioGroup, Transition } from '@headlessui/react'

function DetailJasaSL(props) {

  return (
    <div className="bg-white ">

      <div className="pt-6 animate-pulse">


        {/* Image gallery */}
        <div className="bg-slate-300 h-48 rounded-lg mx-auto mt-6 max-w-2xl sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:gap-x-8 lg:px-8">

        </div>

        {/* Product info */}
        <div className="mx-auto max-w-2xl px-4 pt-10 pb-16 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pt-16 lg:pb-24">
          <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
            <h1 className=" bg-slate-300 h-6"></h1>
          </div>

          {/* Options */}
          <div className="mt-4 lg:row-span-3 lg:mt-0">
            <h2 className="sr-only">Product information</h2>
            <div className='flex items-center rounded-lg '>
              <div className="text-xs flex-1 items-center bg-slate-300 h-12"></div>
            </div>




            {/* Product Package */}
            <div className='mt-6 rounded-lg bg-slate-300 h-64'>

            </div>

            <form className="mt-10">

              <div className="mt-10 ">

                <div className="bg-slate-300 h-96 rounded-lg ">

                </div>
              </div>
              <button
                type="submit"
                className="mt-10 animate-bounce flex rounded-lg mx-auto mb-12 
                sticky bottom-12 items-center justify-center border border-transparent 
                bg-primaryRed py-3 px-8 text-sm font-medium text-white hover:bg-amber-600 
                focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
              >
                <CalendarDaysIcon className='w-6 text-white mr-3' />
                Pesan Sekarang
              </button>

            </form>
          </div>

          <div className="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pt-6 lg:pb-16 lg:pr-8">
            {/* Description and details */}
            <div>
              <h3 className="sr-only">Description</h3>

              <div className="space-y-6">
                <p className="text-base text-gray-900 bg-slate-300 h-12"></p>
              </div>
            </div>

            <div className="mt-10">
              <h3 className="text-sm font-medium text-gray-900 bg-slate-300 h-6 rounded"></h3>

              <div className="mt-4">
                <ul role="list" className="list-disc space-y-2 pl-4 text-sm">

                  <li className="bg-slate-300">
                    <span className="h-6 rounded"></span>
                  </li>

                  <li className="bg-slate-300">
                    <span className="h-6 rounded"></span>
                  </li>

                  <li className="bg-slate-300">
                    <span className="h-6 rounded"></span>
                  </li>

                  <li className="bg-slate-300">
                    <span className="h-6 rounded"></span>
                  </li>

                </ul>
              </div>
            </div>

            <div className="mt-10">
              <h2 className="text-sm font-medium text-gray-900 bg-slate-300 rounded h-6"></h2>

              <div className="mt-4 space-y-6">
                <p className="text-sm text-gray-600 bg-slate-300 rounded h-6"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailJasaSL;